import React from 'react'

import { Route, Routes } from 'react-router-dom'

import PropTypes from 'prop-types'

import PageLayout from 'Pods/Layout/PageLayout'
import ContextBasedRouter from 'Pods/Shared/ContextBasedRouter'
import DesignersList from 'Pods/Shared/DesignersList/DesignersList'

function DesignersLayout(props) {
  return (
    <ContextBasedRouter initialPathname="/designers">
      <Routes>
        <Route
          path="/designers"
          element={(
            <PageLayout
              component={DesignersList}
              navigation={props.navigation}
              footer={props.footer}
              navClass={props.navClass}
              navId={props.navId}
              data={props.layout.data}
              meta={props.layout.meta}
              messagingForbidden={props.layout.messagingForbidden}
            />
          )}
        />
      </Routes>
    </ContextBasedRouter>
  )
}

DesignersLayout.propTypes = {
  layout: PropTypes.shape({
    data: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
    messagingForbidden: PropTypes.bool,
  }).isRequired,
}

export default DesignersLayout
